import type { PublicRoute } from "../../../routes/registry";
import AboutPage from "./AboutPage";

/** BR-WEB-004 — legacy About title (typo "Toowomba" fixed) and meta description (baseline § 3). */
const route: PublicRoute = {
  path: "/about",
  element: <AboutPage />,
  title:
    "Our Services, team and awards set us apart as Toowoomba's leading Outdoor Living products experts | Greatway Patios",
  description:
    "Throughout the years, the high-skilled and professional team of Greatway Patios has been designing and building award winning outdoor patios and rooms where families build lasting memories.",
};

export default route;
